/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Action_ErrorInputs */

const fr_guardian_action_error = /** @type {(inputs: Guardian_Action_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'action a échoué`)
};

/**

* @param {Guardian_Action_ErrorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_action_error = /** @type {((inputs?: Guardian_Action_ErrorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Action_ErrorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_action_error(inputs)
});